import * as React from 'react'

import { DataTableChip, Tooltip, pluralize, } from "../../Shared";

// this method computes the sum of rounded individual timespent values,
// so that the displayed output of aggregated sessions matches
// what the user would see if they looked at the sessions individually and summed them

export function getRoundedTotalTimeSpentString(secondsArray: number[]): string {
  if (secondsArray.reduce((seconds, sum) => sum + seconds, 0) === 0) { return 'N/A'}

  const roundedMinutesArray = secondsArray.map(seconds => Math.floor(seconds / 60))
  const totalRoundedMinutes = roundedMinutesArray.reduce((seconds, sum) => sum + seconds, 0)

  if (totalRoundedMinutes < 1) return '<1 min';
  if (totalRoundedMinutes < 60) return `${totalRoundedMinutes} ${pluralize(totalRoundedMinutes, 'min', 'mins')}`;

  const hours = Math.floor(totalRoundedMinutes / 60);
  const minutes = totalRoundedMinutes % 60;
  const hoursText = pluralize(hours, 'hr', 'hrs');

  if (minutes === 0) {
    return `${hours} ${hoursText}`;
  } else {
    const minuteText = pluralize(minutes, 'min', 'mins');
    return `${hours} ${hoursText} ${minutes} ${minuteText}`;
  }
}

export function getTimeSpent(seconds: number) {
  if(!seconds) {
    return 'N/A';
  }
  if(seconds < 60) {
    return `<1 min`;
  }
  if(seconds >= 60 && seconds < 120) {
    return '1 min';
  }
  if(seconds >= 120 && seconds < 3600) {
    return `${Math.floor((seconds % 3600) / 60)} mins`;
  }
  if(seconds >= 3600 && seconds < 3660) {
    return '1 hr';
  }
  const hours = Math.floor(seconds / 60 / 60);
  const minutes = Math.floor((seconds % 3600) / 60)
  const hoursText = pluralize(hours, 'hr', 'hrs');
  if(minutes) {
    const minuteText = pluralize(minutes, 'min', 'mins');
    return `${hours} ${hoursText} ${minutes} ${minuteText}`;
  }
  return `${hours} ${hoursText}`;
}

interface renderTooltipRowProps {
  color?: string,
  icon?: {
    alt: string,
    src: string
  }
  id: number,
  label: string,
  link?: string,
  headerWidth: number
}

export function renderTooltipRow({ color, icon, id, label, link, headerWidth }: renderTooltipRowProps) {
  const averageFontWidth = 8
  let style: React.CSSProperties = { width: `${headerWidth}px`, minWidth: `${headerWidth}px` }
  const dataTableChip = <DataTableChip color={color} icon={icon} label={label} link={link} />
  if ((String(label).length * averageFontWidth) >= headerWidth) {
    return (
      <Tooltip
        key={id}
        tooltipText={label}
        tooltipTriggerStyle={style}
        tooltipTriggerText={dataTableChip}
        tooltipTriggerTextStyle={style}
      />
    )
  } else {
    return dataTableChip
  }
}
